var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhereYourMoneyGoesMainuk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 300 300"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BCDCDA",
  d: "M273.982 232.876a145.004 145.004 0 0 1-227.645 13.131A145.005 145.005 0 0 1 26.569 82.69a145 145 0 0 1 224.205-41.558L155 150z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#015d59",
  d: "M265.609 226.594a135.003 135.003 0 0 1-211.975 11.703 135.002 135.002 0 0 1 38.76-208.73 135 135 0 0 1 152.048 18.454l-89.419 101.14z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F27B30",
  d: "M244.139 48.546a135.005 135.005 0 0 1 36.196 149.542l-125.921-48.674z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCD03",
  d: "M280.205 198.422a135 135 0 0 1-13.72 26.26l-112.071-75.268z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#D22267",
  d: "M266.451 224.778q-.947 1.407-1.929 2.791l-110.09-78.136z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M204.87 149.143c0 27.614-22.385 50-50 50s-50-22.386-50-50 22.386-50 50-50 50 22.386 50 50"
})));
export default SvgWhereYourMoneyGoesMainuk;